import { headers, saveAsFile } from "libs/api/interceptors";

export default function receipts(client, config) {
  const path = `/widgets/${config.widgetUUID}/receipts`;
  return {
    create: (data) => client.request({
      endpoint: path,
      method: "POST",
      body: data,
    }),
    list: () => client.request({
      endpoint: path,
      method: "GET",
    }),
    getPDF: (id, filename) => client.request({
      endpoint: `${path}/${id}`,
      method: "GET",
      responseInterceptors: [saveAsFile(filename)],
      interceptors: [headers({ accept: "application/pdf" })],
    }),
    previewReceiptTotals: (actionConfig) => client.request({
      endpoint: `${path}/actions`,
      version: "v2",
      body: {
        type: "PREVIEW_RECEIPT_TOTALS",
        config: actionConfig,
      },
      method: "POST",
    }),
    sendReceiptByEmail: (id) => client.request({
      endpoint: `${path}/${id}/actions`,
      version: "v2",
      body: {
        type: "SEND_RECEIPT_BY_EMAIL",
      },
      method: "POST",
    }),
  };
}
